import {
  CheckCircleFilled,
  DeleteFilled,
  ExclamationCircleFilled,
  FormOutlined,
  HourglassOutlined,
  QuestionCircleFilled,
  SyncOutlined,
  TeamOutlined,
} from '@ant-design/icons';

import { Tooltip } from 'antd';
import _ from 'lodash';
import React from 'react';
import {
  FAILED_STATUS,
  FINISHED_STATUS, KILLED_STATUS,
  QUEUE_STATUS,
  RUNNING_STATUS, SUBMITTED_STATUS,
  WAITING_STATUS
} from "./CohortBuilder/cohortStatus";

const blue = { color: '#4390f7' }
const green = { color: '#39c976' }
const red = { color: '#ff1d25' }

const draft = (type: string) => {
  return (
    <Tooltip title={`draft ${type}`}>
      <FormOutlined style={blue} />
    </Tooltip>
  );
}

interface Props {
  type: ("query" | "report" | "pathway")
  status: string
  whenStatusIsNull?: JSX.Element
}

const SparkQueryStatus = ({ type, status, whenStatusIsNull = draft(type) }: Props) => {

  const determineContent = () => {
    if (!_.isNil(status)) {
      switch (status.toLowerCase()) {
        case RUNNING_STATUS:
          return (
            <Tooltip title={`running ${type}`}>
              <SyncOutlined spin={true} style={blue} />
            </Tooltip>
          );
        case FINISHED_STATUS:
          return (
            <Tooltip title={`finished ${type}`}>
              <CheckCircleFilled style={green} />
            </Tooltip>
          );
        case FAILED_STATUS:
          return (
            <Tooltip title={`failing ${type}`}>
              <ExclamationCircleFilled style={red} />
            </Tooltip>
          );
        case WAITING_STATUS:
          return (
            <Tooltip title={`waiting to run`}>
              <HourglassOutlined style={blue} />
            </Tooltip>
          );
        case QUEUE_STATUS:
          return (
            <Tooltip title={`waiting in queue to run`}>
              <TeamOutlined style={blue} />
            </Tooltip>
          );
        case KILLED_STATUS:
          return (
            <Tooltip title={`${type} was stopped by user`}>
              <DeleteFilled style={red} />
            </Tooltip>
          );
        case SUBMITTED_STATUS:
          return (
            <Tooltip title={`submitted but failed to join queue, will retry again`}>
              <TeamOutlined style={blue} />
            </Tooltip>
          );
        default:
          // happens when the backend has failed to run a job and the status is an empty string
          return (
            <Tooltip title={"failed for unknown reason"}>
              <QuestionCircleFilled style={red} />
            </Tooltip>
          );
      }
    } else {
      return whenStatusIsNull
    }
  }

  return determineContent()

}

export default SparkQueryStatus